"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const IconContainer_1 = __importDefault(require("../IconContainer"));
const StyledPathOne = styled_components_1.default.path `
  fill: ${({ theme }) => theme.palette.orange[10]};
`;
const StyledPathTwo = styled_components_1.default.path `
  fill: ${({ theme }) => theme.palette.red[50]};
`;
const BookmarkRedIcon = ({ size = 24, ...rest }) => ((0, jsx_runtime_1.jsxs)("svg", { fill: "none", height: size, viewBox: "0 0 24 24", width: size, xmlns: "http://www.w3.org/2000/svg", ...rest, children: [(0, jsx_runtime_1.jsx)(StyledPathOne, { d: "M9.464 22c.789 0 1.44-.637 1.44-1.438V2H3.44C2.651 2 2 2.637 2 3.437V22h7.464z" }), (0, jsx_runtime_1.jsx)(StyledPathTwo, { d: "M10.466 2c-.789 0-1.44.637-1.44 1.437V22H20.56c.789 0 1.44-.637 1.44-1.438V2H10.466zm9.668 11.25h-3.369v3.363H14.26V13.25h-3.368v-2.5h3.369V7.387h2.504v3.363h3.369v2.5z" }), (0, jsx_runtime_1.jsx)("path", { d: "M20.147 13.237h-3.37V16.6h-2.504v-3.363h-3.369v-2.5h3.37V7.375h2.504v3.362h3.369v2.5z", fill: "#fff" })] }));
exports.default = (0, IconContainer_1.default)(BookmarkRedIcon);
//# sourceMappingURL=index.js.map